import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = () => (
  <Svg width="20" height="20" viewBox="0 0 24 25" fill="none">
    <Path
      d="M18.75 5.68945L5.25 19.3156"
      stroke="#2B2845"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <Path
      d="M18.75 19.3156L5.25 5.68945"
      stroke="#2B2845"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </Svg>
);

const CloseIcon = memo(SvgComponent);
export default CloseIcon;
